import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconForecast = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.78974 4C9.73632 4 10.5118 4.72103 10.5804 5.63559L10.5853 5.7675V5.76754H13.4282V5.7675L13.4332 5.63559C13.5017 4.72103 14.2772 4 15.2238 4H16.4028L16.5502 4.00594C17.2328 4.06109 17.8297 4.49592 18.0786 5.133L20.0952 10.5625C21.2516 11.4177 21.9995 12.7791 21.9995 14.3125C21.9995 16.9013 19.8675 19 17.2376 19C14.6077 19 12.4757 16.9013 12.4757 14.3125C12.4757 13.2569 12.8301 12.2829 13.4282 11.4993V10.1863H10.5853V11.5119H10.5803C11.1727 12.2933 11.5233 13.2626 11.5233 14.3125C11.5233 16.9013 9.39134 19 6.76142 19C4.13149 19 1.99951 16.9013 1.99951 14.3125C1.99951 12.7337 2.79243 11.3372 4.00764 10.4878L5.93592 5.17302C6.17519 4.51354 6.78508 4.05961 7.48563 4.00545L7.62687 4H8.78974ZM6.2163 9.65538C6.39518 9.63531 6.57708 9.625 6.76142 9.625C7.48684 9.625 8.17438 9.78468 8.78974 10.0703V5.7675H7.62687L6.2163 9.65538ZM15.2238 10.0636C15.8354 9.78218 16.5179 9.625 17.2376 9.625C17.4725 9.625 17.7034 9.64174 17.9291 9.67407L16.4028 5.7675H15.2238V10.0636ZM13.4282 7.53504V8.41879H10.5853V7.53504H13.4282ZM6.76095 11.5C5.183 11.5 3.90381 12.7592 3.90381 14.3125C3.90381 15.8658 5.183 17.125 6.76095 17.125C8.33891 17.125 9.61809 15.8658 9.61809 14.3125C9.61809 12.7592 8.33891 11.5 6.76095 11.5ZM17.2371 11.5C15.6592 11.5 14.38 12.7592 14.38 14.3125C14.38 15.8658 15.6592 17.125 17.2371 17.125C18.8151 17.125 20.0943 15.8658 20.0943 14.3125C20.0943 12.7592 18.8151 11.5 17.2371 11.5Z"
        />
      </svg>
    );
  }
);
